import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import {onMounted, reactive} from "vue";
import {onBeforeRouteUpdate} from "vue-router";
import {useSpinner} from "@/shared/composables/SogSpinner";
import apiStore from "@/modules/Store/api";
import {useAccountStore} from "@/stores/accountStore";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import DeliveryCardComponent from "@/modules/Store/components/DeliveryCardComponent.vue";
import OrderHead from "@/shared/model/orderHead";
import OrderItem from "@/shared/model/orderItem";
import notificationService from "@/shared/services/NotificationService";
import apiOrder from "@/modules/Order/api";



export default /*@__PURE__*/_defineComponent({
  __name: 'DeliveryListPage',
  setup(__props) {

const _spinner = useSpinner()
const _accountStore = useAccountStore();
const _orders = reactive<OrderHead[]>([])
const _orderItems = reactive<OrderItem[]>([])

async function p_init() {
  _orders.length = 0;
  _orderItems.length = 0;
  if (!_accountStore.person?.id)
    return
  _spinner.show()
  try {
    const res = await apiStore.listDelivery(_accountStore.person.id)
    if (res?.orderHeads) {
      _orders.push(...res.orderHeads)
    }
    if (res?.orderItems) {
      _orderItems.push(...res.orderItems)
    }
  } finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  await p_init()
})

onBeforeRouteUpdate(async () => {
  await p_init()
});


function getOrderItems(id?: string): OrderItem[] {
  return _orderItems.filter(t => t.id == id)
}

async function onDelivery(order?: OrderHead) {
  if (!order?.id)
    return
  try {
    _spinner.show()
    if (await apiOrder.delivery(order.id)) {
      notificationService.success("Bestellung " + order.orderNumber + " wurde angenohmen")
      await p_init();
    }
  } finally {
    _spinner.hide()
  }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: "Lieferungen"
  }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, null, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Refresh,
                onClick: p_init
              }, null, 8, ["kind"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(SogCardContent, null, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Sie haben keine Lieferungen ", -1)
            ]))]),
            _: 1
          }, 512), [
            [_vShow, _orders.length===0]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_orders, (item) => {
            return (_openBlock(), _createBlock(SogCardContent, { key: item }, {
              default: _withCtx(() => [
                _createVNode(DeliveryCardComponent, {
                  "order-head": item,
                  "order-items": getOrderItems(item.id)
                }, {
                  default: _withCtx(() => [
                    _createVNode(SogCardActions, null, {
                      default: _withCtx(() => [
                        _createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-truck-check",
                          tooltip: "Bestellung annehmen",
                          onClick: ($event: any) => (onDelivery(item))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["order-head", "order-items"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})